import React from "react";
import { Box, TextField, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import HomeImg from "../images/img-smile.png"

const LeftText = () => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('xl')); 

  return (
    <Box
      width={{ xs: "100%", lg: "60%" }}
      mb={{ xs: "10%", lg: "0" }}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Typography
        sx={{
          fontSize: "16px",
          lineHeight: {
            xs: "5vw",
            sm: "5vw",
            md: "5vw",
            lg: "3vw",
          },
          fontWeight: {
            xs: "500",
            sm: "500",
            md: "500",
            lg: "900",
          },
          color: "#33AEA0",
          textTransform: "uppercase",
        }}
        // align="center"
      >
        SEE HOW MUCH YOU COULD SAVE WITH BKV ENERGY - SWITCH AND SAVE TODAY
      </Typography>
      <Typography
        sx={{
          fontSize: {
            xs: "5.5vw",
            sm: "5.5vw",
            md: "5vw",
            lg: "35px",
            xl: "40px",
            xxl:"60px"
          },
          color: theme.palette.primary.main,
          whiteSpace: "wrap",
          // marginBottom: { xs: "10%", sm: "10%", md: "6%", lg: "2%" },
        }}
        // align="center"
        variant="body2"
        // padding={{ xs: "0 10%", sm: "0 10%", md: "0 10%", lg: "0 5%" }}
      >
        Discover Electricity Savings: Upload Your Bill to Instantly Compare Plans!
      </Typography>
      <img src={HomeImg} width="60%" style={{margin:'10px 0', borderRadius:30}}/>
      <ul style={{ marginLeft: "1rem" }}>
        <li>
          <Typography
            sx={{
              fontSize: "16px",
            }}
            variant="body1"
          ><b>
            INSTANT UPLOAD:&nbsp;
          </b>
            Drag and drop your bil!
          </Typography>
        </li>
        <li>
          <Typography
            sx={{
              fontSize: "16px",
            }}
            variant="body1"
          >
            <b>QUICK VERIFICATION:&nbsp;</b>
            Confirm your plan details
          </Typography>
        </li>
        <li>
          <Typography
            sx={{
              fontSize: "16px",
            }}
            variant="body1"
          >
            <b>SHOP ENERGY SAVINGS:&nbsp;</b>
            Find the perfect electricity plan with BKVE
          </Typography>
        </li>
      </ul>
    </Box>
  );
};

export default LeftText;
